import { isEdge } from 'react-device-detect'
import { useState, useEffect } from 'react'
import { XMarkIcon } from '@heroicons/react/24/outline'

export const EdgeBrowserBanner = () => {
  const [dismissed, setDismissed] = useState(false)

  useEffect(() => {
    const isDismissed = localStorage.getItem('edge-banner-dismissed')
    if (isDismissed === 'true') {
      setDismissed(true)
    }
  }, [])

  const handleDismiss = () => {
    setDismissed(true)
    localStorage.setItem('edge-banner-dismissed', 'true')
  }

  if (!isEdge || dismissed) return null

  return (
    <div className="relative bg-yellow-50 border-b border-yellow-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="py-2 pr-12 sm:pr-14">
          <p className="text-sm text-yellow-800">
            <span className="font-medium">⚠️ Better Experience Available:</span>{' '}
            <span className="inline">
              For optimal performance, we recommend using{' '}
              <a href="https://www.google.com/chrome/" target="_blank" rel="noopener noreferrer" className="underline font-medium">
                Chrome
              </a>
              ,{' '}
              <a href="https://www.mozilla.org/firefox/" target="_blank" rel="noopener noreferrer" className="underline font-medium">
                Firefox
              </a>
              , or{' '}
              <a href="https://www.apple.com/safari/" target="_blank" rel="noopener noreferrer" className="underline font-medium">
                Safari
              </a>
              .
            </span>
          </p>
        </div>
        <button
          type="button"
          onClick={handleDismiss}
          className="absolute top-1/2 right-2 -translate-y-1/2 p-1 rounded-md text-yellow-800 hover:bg-yellow-100 focus:outline-none focus:ring-2 focus:ring-yellow-600"
          aria-label="Dismiss"
        >
          <XMarkIcon className="h-5 w-5" aria-hidden="true" />
        </button>
      </div>
    </div>
  )
}